import { replacer } from "./nameFormatter";

export default function formPoolStructure(collection) {
  return collection.reduce((acc, pool) => {
    acc[replacer(pool.poolName)] = {};
    return acc;
  }, {});
}
